import React, { useState, useEffect } from "react";

const DotNavigation = ({ sections, activeSection, onSectionClick }) => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getDotSize = () => {
    if (windowSize.width < 640) return "w-2 h-2"; // Mobile
    if (windowSize.width < 1024) return "w-2.5 h-2.5"; // Tablet
    return "w-3 h-3"; // Desktop
  };

  const getGapSize = () => {
    if (windowSize.width < 640) return "gap-3"; // Mobile
    if (windowSize.width < 1024) return "gap-3.5"; // Tablet
    return "gap-4"; // Desktop
  };

  return (
    <div className="fixed right-3 sm:right-4 top-1/2 transform -translate-y-1/2 z-50">
      <div className={`flex flex-col ${getGapSize()}`}>
        {sections.map((section) => (
          <div key={section.id} className="relative group">
            <button
              onClick={() => onSectionClick(section.id)}
              className={`${getDotSize()} rounded-full transition-all duration-300 ${
                activeSection === section.id
                  ? "bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53]"
                  : "bg-gray-400 hover:bg-gray-500"
              }`}
              aria-label={`Go to ${section.name}`}
            />
            <div
              className="absolute right-8 top-1/2 transform -translate-y-1/2 
                          bg-gray-800 text-white text-sm px-2 py-1 rounded 
                          opacity-0 group-hover:opacity-100 transition-opacity duration-200
                          whitespace-nowrap pointer-events-none"
            >
              {section.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DotNavigation;
